import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const chatApi = createApi({
    reducerPath: "chatApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    // Define all endpoints inside this single `endpoints` function
    endpoints: (builder) => ({
        getAllChatList: builder.query({
            query: ({ email }) => ({
                url: `admin-chat/list/?email=${email}`
            }),
            transformResponse: (response) => response.data
        }),
        getAllMessages: builder.query({
            query: ({ from, to, id }) => ({
                url: `admin-chat/messages/?from=${from}&to=${to}&id=${id}`
            }),
            transformResponse: (response) => response.data
        })
    })
});

export const { useGetAllChatListQuery, useGetAllMessagesQuery } = chatApi;
